import { AuthContext } from '@repo-level/core-front';
import { AnalyticsEventName } from 'api/analytics';
import { ModalsContext, ModalType } from 'contexts/modal';
import { useAnalytics } from 'helpers/analytics';
import { useContext, useEffect } from 'react';

export const useNewTermsAndConditions = () => {
  const { user } = useContext(AuthContext);
  const { handleModal, modals } = useContext(ModalsContext);
  const { sendEventToAnalytics } = useAnalytics();

  useEffect(() => {
    if (modals.length) return;

    if (user && user.authFieldsMissed.includes('terms_acceptance')) {
      handleModal(ModalType.NewTermsAndConditions)();
      sendEventToAnalytics({
        name: AnalyticsEventName.MODAL__TERMS_AND_SERVICES__SHOW,
        attributes: {
          additionalData: JSON.stringify({
            authFieldsMissed: ['terms_acceptance'],
          }),
        },
      });
    }
  }, [handleModal, modals.length, sendEventToAnalytics, user]);
};
